import { render, staticRenderFns } from "./AscBoxChart.vue?vue&type=template&id=892a2e98&scoped=true&"
import script from "./AscBoxChart.vue?vue&type=script&lang=js&"
export * from "./AscBoxChart.vue?vue&type=script&lang=js&"
import style0 from "./AscBoxChart.vue?vue&type=style&index=0&id=892a2e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892a2e98",
  null
  
)

export default component.exports